import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.9057 6.34633C11.9057 9.58601 9.3417 12.1927 6.20283 12.1927C3.06396 12.1927 0.5 9.58601 0.5 6.34633C0.5 3.10665 3.06396 0.5 6.20283 0.5C9.3417 0.5 11.9057 3.10665 11.9057 6.34633Z",
      fill: "white",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.9057 23.653C11.9057 26.8926 9.3417 29.4993 6.20283 29.4993C3.06396 29.4993 0.5 26.8926 0.5 23.653C0.5 20.4133 3.06396 17.8066 6.20283 17.8066C9.3417 17.8066 11.9057 20.4133 11.9057 23.653Z",
      fill: "white",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.5 14.6162C29.5 17.9532 26.859 20.6387 23.625 20.6387C20.391 20.6387 17.75 17.9532 17.75 14.6162C17.75 11.2793 20.391 8.59375 23.625 8.59375C26.859 8.59375 29.5 11.2793 29.5 14.6162Z",
      fill: "white",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.75 24.209L14.3182 24.209L14.3182 15.3845M3.75 6.55993L14.3182 6.55993L14.3182 15.3845M14.3182 15.3845L18.75 15.3845",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }